import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
export default function CustomDateRangePicker({
  title = 'Select date & time',
  value,
  onChange,
  open,
  onClose,
  onUpdateDueDate,
  error,
}) {
  const handleChange = (newDateTime) => {
    if (newDateTime) {
      const newValue = {
        date: dayjs(newDateTime).format('YYYY-MM-DD'),
        time: dayjs(newDateTime).format('HH:mm'),
      };
      onChange(newValue);
    }
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle sx={{ pb: 2 }}>{title}</DialogTitle>

      <DialogContent>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Stack spacing={3} sx={{ pt: 1 }}>
            <DateTimePicker
              label="Select Date & Time"
              value={value?.date && value?.time ? dayjs(`${value.date}T${value.time}`) : null}
              onChange={handleChange}
              disablePast
            />
          </Stack>
        </LocalizationProvider>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            onUpdateDueDate();
            onClose();
          }}
          disabled={error}
        >
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
}

CustomDateRangePicker.propTypes = {
  value: PropTypes.shape({
    date: PropTypes.string,
    time: PropTypes.string,
  }),
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  onUpdateDueDate: PropTypes.func,
  open: PropTypes.bool,
  title: PropTypes.string,
  error: PropTypes.bool,
};
